/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useTransition } from 'react-spring';

import { ModalProps } from './Modal.types';
import { ModalContainer } from './ModalContainer';

import { ModalContainer as Container } from './Modal.styles';

export function Modal({ onClose, open, ...props }: ModalProps) {
  const transitions = useTransition(open, {
    from: { opacity: 0, transform: 'translateY(-40px)' },
    enter: { opacity: 1, transform: 'translateY(0px)' },
    leave: { opacity: 0, transform: 'translateY(-40px)' },
  });

  function handleCloseModal() {
    onClose();
  }
  function closeOnEscapeKeyDown(e: KeyboardEvent) {
    if ((e.code || e.key) === 'Escape') {
      handleCloseModal();
    }
  }
  useEffect(() => {
    document.body.addEventListener('keydown', closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener('keydown', closeOnEscapeKeyDown);
    };
  }, []);
  return (
    <>
      {transitions(
        (styles, item) =>
          item && (
            <Container onClick={handleCloseModal} aria-modal={true} role="tmov-modal">
              <ModalContainer style={styles} {...props} onClose={onClose} />
            </Container>
          ),
      )}
    </>
  );
}
